<div class="header-containers">
  <div>
    <h2>
      <a
        [routerLink]="customer ? ['/customers/view', customer?.customerId] : []"
        >{{ customer?.name }}</a
      >
    </h2>
  </div>
  <div *ngIf="customer?.hasPendingChanges" class="moderation-alert">
    {{ 'label.CustomerIsInModeration' | translate }}
  </div>
</div>
<!-- lazyLoad is false because of CKeditor Error -->
<p-tabView styleClass="edit-view" [activeIndex]="tabIndex">
  <p-tabPanel header="{{ 'label.Details' | translate }}">
    <hr-customer-edit-details
      (onUpdate)="onCustomerUpdated($event)"
      [customer]="customer"
      [industryOptions]="industryOptions"
      [localities]="localities"
      [industries]="industries"
      [types]="types"
      [customerFeedTypes]="customerFeedTypes"
      [numberOfEmployees]="numberOfEmployees"
      [portfolios]="portfolios"
    ></hr-customer-edit-details>
  </p-tabPanel>
  <p-tabPanel header="{{ 'label.Billing' | translate }}">
    <hr-customer-edit-billing
      (onUpdate)="onCustomerUpdated($event)"
      [customer]="customer"
      [vatStatuses]="vatStatuses"
    ></hr-customer-edit-billing>
  </p-tabPanel>
  <p-tabPanel header="{{ 'label.CustomerAgents' | translate }}">
    <hr-customer-edit-agents
      (onUpdate)="onCustomerUpdated($event)"
      [customer]="customer"
    ></hr-customer-edit-agents>
  </p-tabPanel>
  <p-tabPanel header="{{ 'label.ContractsAndVerified' | translate }}">
    <hr-customer-edit-contracts-and-verified-view
      (onUpdate)="onCustomerUpdated($event)"
      [customer]="customer"
      [contractTypes]="customerContractTypes"
    ></hr-customer-edit-contracts-and-verified-view>
  </p-tabPanel>
  <p-tabPanel header="{{ 'label.Branding' | translate }}">
    <app-customer-edit-branding
      (onUpdate)="onCustomerUpdated($event)"
      [customer]="customer"
    ></app-customer-edit-branding>
  </p-tabPanel>
  <p-tabPanel header="{{ 'label.CVBoxChannels' | translate }}">
    <hr-customer-cv-box-channels [customerId]="customer?.customerId"></hr-customer-cv-box-channels>
  </p-tabPanel>
</p-tabView>
